<template>
  <div ref="pageRef" class="page">
    <slot />
  </div>
</template>

<script lang="ts" setup>
const pageRef = ref<HTMLElement>();
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  margin: 0 auto;
}
</style>
